module.exports = __webpack_public_path__ + "img/ltkbuynow-2x.fa6727f.jpg";